import * as types from '../../mutation-types';

/**
 * Update the page loading state
 */
export function setPageLoading({ commit }, { isLoading }) {
    commit(types.SET_PAGE_LOADING, { isLoading });
}
